import Vue from 'vue'
import i18n from '@/libs/i18n'

export default async function chunkFailedHandler(error: Error) {
  try {
    if (/Loading chunk .* failed/gi.test(error.message) || /Loading CSS chunk .* failed/.test(error.message)) {
      // @ts-ignore
      let confirm = false

      if (Vue?.prototype?.$swalConfirm) {
        confirm = (await Vue.prototype.$swalConfirm(i18n.t('errors.new-version').toString(), {
          icon: 'warning',
          titleText: i18n.t('errors.new-version').toString(),
          text: i18n.t('errors.new-version-reload').toString(),
          confirmButtonText: i18n.t('errors.new-version-reload-confirm').toString(),
          cancelButtonText: i18n.t('forms.cancel').toString(),
        }))?.value
      } else {
        // eslint-disable-next-line no-alert
        confirm = window.confirm(`${i18n.t('errors.new-version')}, ${i18n.t('errors.new-version-reload')}`)
      }

      if (confirm) {
        window.location.reload()
      }
    }
  } catch (e) {
    console.error(`Error while handling Route error, ${e.message}`)
  }
  console.error(`ROUTER ERROR => ${error.message}`)
}
